<card name="Datepicker">
  <div card content>
    <form class="form-inline mb-3">
      <div class="form-group d-block">
        <label class="mb-1 justify-content-start">Дата с временем</label>

        <daterange-picker [formControl]="date"
                          [clearable]="true"
                          [single]="true"
                          [default]="true"
                          [daysBeforeNow]="3"
                          placeholder="Date" (init)="test()">
        </daterange-picker>
      </div>
      <div class="form-group ml-3 align-self-end">
        <input type="text" class="form-control" placeholder="12:00">
      </div>
    </form>
    <div class="small text-muted mb-4 mt-1">
      Model data: {{ date.value | json }}
    </div>

    <div class="form-group">
      <label>Диапозон дат</label>
      <daterange-picker [formControl]="multipleDate"
                        [clearable]="true"
                        [default]="true"
                        placeholder="Multiple date"
                        (init)="multipleTest()">
      </daterange-picker>
    </div>
    <div class="small text-muted mb-4 mt-1">
      Model data: {{ multipleDate.value | json }}
    </div>
  </div>
</card>
